export const FINTECHS_UPDATE = "FINTECHS_UPDATE";
export const FINTECHS_SHOW = "FINTECHS_SHOW";
